module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1zcX8a/tc-custom/9781440506963.jpg?1730517606472",
      "alt": "This image is the cover for the book Best Sex of Your Life"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Best Sex of Your Life\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this book, noted sex experts Jennifer and Dan reveal 101 salacious secrets for delightful encounters between the sheets. You have sex; and sure, it's okay, maybe occasionally even good. But with this new guide they help you kick it up a notch to have the best sex every time."), _c('br'), _c('br'), _vm._v("Featuring plenty of tips guaranteed to make you blush, you'll learn to get in touch with your inner seductress for orgasmic results. Among the secrets revealedwhy you should...Have sex in front of a mirrorLearn to use all four phases of the female orgasmWatch porn with your manTry some new positionslike the deck chairUse household items (hello spatula and rolling pin!) during foreplay If you're tired of bland, predictable sex, this insider's roadmap to a more satisfying ride will have you screaming, squirting, and spending the day (or week...or month!) in bed.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennifer Hunt, Dan Baritchi, Nancy J. Price, Betsy Bailey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An Adams Media author.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0